import { translate } from "src/i18n/translate";

export const autofixFeedbackOf = (warnings: readonly string[]) => {
  const partialSearch = warnings.some((warning) =>
    /search limit|not all been tested|budget|time limit/i.test(warning),
  );
  const limits = [
    ...new Set(
      warnings.flatMap((warning) => {
        if (/search limit|not all been tested|budget|time limit/i.test(warning)) return [];
        if (/used width.*exceeds|merchandisableWidth/i.test(warning))
          return [translate("spacePlanning", "proofing.autofix.limitWidth")];
        if (/depth|stock\/supply|maximum days|aggregate stock/i.test(warning))
          return [translate("spacePlanning", "proofing.autofix.limitDepth")];
        if (/alignment|overlap|other plan checks/i.test(warning))
          return [translate("spacePlanning", "proofing.autofix.limitGrouping")];
        return [warning];
      }),
    ),
  ];
  return { partialSearch, limits };
};
